import * as React from 'react';
import { CopyIcon } from '../../utils/copy';


export const InfoBlock = ({ name, lines }: { name: string; lines: { name: string; value: string; hideCopy?: boolean; }[]; }) => {
    const handleClick = React.useCallback((e: React.MouseEvent) => (e.target as HTMLElement).classList.remove("truncate"), []);

    return <>
        <div className="stepName">{name}</div>
        <ul>
            {lines.map(_ => <li key={_.name}>
                <label>{_.name}</label>
                <div className="oauth-prop">
                    <span className="truncate" onClick={handleClick} aria-hidden={true} >{_.value}</span>
                    {!_.hideCopy && <CopyIcon text={_.value} />}
                </div>
            </li>)}
        </ul>
    </>;
};
